import {
    FunctionField,
    ListContextProvider,
    TextField,
    useList,
    useRecordContext,
    useTranslate,
} from "react-admin";
import { Box, Button, CircularProgress } from "@mui/material";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { RaDateField } from "shared/src/components/fields/Ra/RaDateField";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";
import { useInfiniteScroll } from "shared/src/hooks/useInfiniteScroll";
import { getInspectionCreateLink } from "../../skuInspections/getInspectionCreateLink";

export const SkuInspections = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const { data, isPending, isFetchingNextPage, observerRef } = useInfiniteScroll(
        "skuInspections",
        {
            filter: { sku: record?.id },
            pagination: { page: 1, perPage: 25 },
            sort: { field: "date", order: "DESC" },
        },
        {
            enabled: !!record?.id,
        }
    );
    const listContext = useList({ data, resource: "skuInspections" });

    if (isPending) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box>
            <Box sx={{ my: 2 }}>
                <Button
                    variant="text"
                    startIcon={<FactCheckIcon />}
                    href={getInspectionCreateLink(record, "sku")}
                >
                    {translate("equip.recordInspection")}
                </Button>
            </Box>
            <ListContextProvider value={listContext}>
                <DatagridWithHistory bulkActionButtons={false}>
                    <FunctionField
                        label="equip.inspectionType"
                        render={(rowRecord) =>
                            translate(`equip.skuInspectionType_${rowRecord.type}`)
                        }
                    />
                    <FunctionField
                        label="equip.inspectionResult"
                        render={(rowRecord) =>
                            translate(`equip.skuInspectionResult_${rowRecord.result}`)
                        }
                    />
                    <RaDateField label="equip.date" source="date" />
                    <TextField label="equip.comment" source="comment" />
                    <TextField label="equip.createdBy" source="createdBy.fullName" />
                </DatagridWithHistory>
            </ListContextProvider>
            <Box ref={observerRef} sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                {isFetchingNextPage && <CircularProgress size={24} />}
            </Box>
        </Box>
    );
};